import axios from 'axios'
import merge from 'lodash/merge'
import qs from 'qs'
import {
  Message,
  Loading
} from 'element-ui'

const service = axios.create({
  baseURL: 'https://v2.api.h2ocloud.net/api_h2o' // api 的 base_url
})

// 超时时间
service.defaults.timeout = 100000
// 跨域请求，允许保存cookie
service.defaults.withCredentials = true

service.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8'

/**
 * 请求拦截
 */
let loading
service.interceptors.request.use(config => {
  let showLoading = false
  if (config.loading === true) {
    showLoading = true
  }
  if (showLoading) {
    loading = Loading.service({
      text: config.loadingText || 'Loading...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  }
  const token = window.localStorage.getItem('token')
  const tenant = window.localStorage.getItem('tenant')
  // 请求头带上token
  config.headers.token = token
  config.headers.Authorization = 'Bearer ' + token
  config.headers.tenant = tenant
  // 请求地址处理
  const type = config.method
  const defaults = {}
  const arrayFormat = config.headers.arrayFormat || 'indices'
  if (type === 'post' && config.headers['Content-Type'] === 'application/x-www-form-urlencoded; charset=utf-8') {
    // post请求参数处理
    config.data = qs.stringify(config.data, { allowDots: true, arrayFormat: arrayFormat })
  } else if (type === 'get') {
    // get请求参数处理
    config.params = qs.stringify(config.params, { allowDots: true, arrayFormat: arrayFormat })
    config.params = qs.parse(config.params)
    config.params = merge(defaults, config.params)
  }
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
service.interceptors.response.use(response => {
  if (loading) {
    loading.close()
  }
  if (response.data && response.data.success === false) {
    Message({
      message: response.data.msg,
      type: 'error',
      showClose: true,
      dangerouslyUseHTMLString: true,
      duration: 3000,
      customClass: 'zZindex'
    })
  }
  return response
}, error => {
  console.log(error)
})

export default service
